import { Row, intlShape, withIntl } from "lcm-iot-commons";

const getRegTypeRegAddressAndBitInfo = (
  regType: $TSFixMe,
  regBegin: $TSFixMe,
  regEnd: $TSFixMe,
  bitBegin: $TSFixMe,
  bitEnd: $TSFixMe,
) => {
  if (!bitBegin && !bitEnd) {
    return regBegin === regEnd
      ? `${regType}, ${regBegin}`
      : `${regType}, ${regBegin} - ${regEnd}`;
  }
  if (!bitEnd) {
    return `${regType}, ${regBegin} (bit ${bitBegin})`;
  }
  return regBegin === regEnd
    ? `${regType}, ${regBegin} (bits ${bitBegin} - ${bitEnd})`
    : `${regType}, ${regBegin} - ${regEnd} (bits ${bitBegin} - ${bitEnd})`;
};

type Props = {
  itemRegisterType: string;
  itemRegisterBegin: string;
  itemRegisterEnd: string;
  itemBitBegin: string;
  itemBitEnd: string;
  intl: intlShape;
};

export function FieldGatewayGenericModbusDiagnosisItem({
  itemRegisterType,
  itemRegisterBegin,
  itemRegisterEnd,
  itemBitBegin,
  itemBitEnd,
  intl,
}: Props) {
  const { t } = intl;
  return (
    <Row>
      <div className="col-lg-3">
        {/* @ts-expect-error TS(2349) FIXME: This expression is not callable. */}
        <b>{t`field_gateway.modbus.config.item.command_register`}</b>
      </div>
      <div className="col-lg-6">
        {getRegTypeRegAddressAndBitInfo(
          itemRegisterType,
          itemRegisterBegin,
          itemRegisterEnd,
          itemBitBegin,
          itemBitEnd,
        )}
      </div>
    </Row>
  );
}

export default withIntl(FieldGatewayGenericModbusDiagnosisItem);
